import { z } from 'zod';

/** Unix epoch milliseconds measured by the server clock. All persisted times use this unit. */
export const TimestampMsSchema = z.number().int().nonnegative();
export type TimestampMs = z.infer<typeof TimestampMsSchema>;
